(() => {
  function setActiveCard(widgetEl, value) {
    const cards = widgetEl.querySelectorAll(".fh-card");
    cards.forEach((card) => card.classList.remove("fh-card--active"));

    const input = widgetEl.querySelector(`input[name="fh_purchase"][value="${value}"]`);
    if (!input) return;

    const card = input.closest(".fh-card");
    if (card) card.classList.add("fh-card--active");
  }

  function updateForm(widgetEl, purchaseValue) {
    const formEl = widgetEl.closest("form");
    if (!formEl) return;

    const variant30 = widgetEl.dataset.variant30;
    const variant60 = widgetEl.dataset.variant60;
    const planSingle = widgetEl.dataset.sellingPlanSingle || "";
    const planDouble = widgetEl.dataset.sellingPlanDouble || "";

    // Hidden variant input in Refresh theme product form
    const variantIdInput = formEl.querySelector('input[name="id"].product-variant-id') 
      || formEl.querySelector('input[name="id"]');

    // Hidden selling_plan_id input (in jouw widget)
    const sellingPlanInput = widgetEl.querySelector('#fh-selling-plan-id')
      || formEl.querySelector('input[name="selling_plan_id"]');

    let nextVariantId = variant30; // default
    let nextSellingPlanId = "";

    if (purchaseValue === "single_sub") {
      nextVariantId = variant30;
      nextSellingPlanId = planSingle;
    } else if (purchaseValue === "double_sub") {
      nextVariantId = variant60;
      nextSellingPlanId = planDouble;
    } else {
      // onetime
      nextVariantId = variant30;
      nextSellingPlanId = "";
    }

    if (variantIdInput) {
      variantIdInput.value = nextVariantId;
      // Trigger change so Shopify/Theme scripts can react (some apps/themes listen to it)
      variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    if (sellingPlanInput) {
      sellingPlanInput.value = nextSellingPlanId;
      sellingPlanInput.dispatchEvent(new Event("change", { bubbles: true }));
    }

    setActiveCard(widgetEl, purchaseValue);
  }

  function initWidget(widgetEl) {
    // Initial state: whichever is checked
    const checked = widgetEl.querySelector('input[name="fh_purchase"]:checked');
    updateForm(widgetEl, checked ? checked.value : "onetime");

    // Listen changes
    widgetEl.addEventListener("change", (e) => {
      const t = e.target;
      if (!t || t.name !== "fh_purchase") return;
      updateForm(widgetEl, t.value);
    });

    // Make whole card clickable (label already helps, but this makes it robust)
    widgetEl.querySelectorAll(".fh-card").forEach((card) => {
      card.addEventListener("click", () => {
        const radio = card.querySelector('input[name="fh_purchase"]');
        if (!radio) return;
        radio.checked = true;
        updateForm(widgetEl, radio.value);
      });
    });
  }

  function boot() {
    document.querySelectorAll(".fh-widget").forEach(initWidget);
  }

  // Shopify theme editor / dynamic sections
  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", boot);
})();
